__turbopack_context__.v({
  "celebrityItem": "FilterCelebrities-module__0elfga__celebrityItem",
  "closeIcon": "FilterCelebrities-module__0elfga__closeIcon",
  "closeIconAppear": "FilterCelebrities-module__0elfga__closeIconAppear",
  "dropdown": "FilterCelebrities-module__0elfga__dropdown",
  "dropdownAppear": "FilterCelebrities-module__0elfga__dropdownAppear",
  "mobileFilterContent": "FilterCelebrities-module__0elfga__mobileFilterContent",
  "searchIcon": "FilterCelebrities-module__0elfga__searchIcon",
  "searchInput": "FilterCelebrities-module__0elfga__searchInput",
  "sortButton": "FilterCelebrities-module__0elfga__sortButton",
  "sortIcon": "FilterCelebrities-module__0elfga__sortIcon",
});
